import * as DashboardConstants from "../../constants/DashboardConstants";
import {geCSVColumns, getByColName, resultSetSize} from "../charts/DashBoardResultSetUtil";
import {fillWithLastElement} from "../../common/CollectionsUtility";
import {addDataLine} from "../charts/ColumnWithCategDrawer";
import {prepareChartData} from "./HighChartsDrawer";
import {calcChartTitle} from "./HighGaugeDrawer";
import {addLinkOptionsToPoint, handleChartClick} from "./HighPieChartDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createHighColumnsChart(userDashboardChartLine, h, w, widget, Highcharts) {
    let values = userDashboardChartLine.resultSet;
    let params = userDashboardChartLine.parameters;
    let categs = [];
    let labelWithValues = new Map();
    let categParam = params[DashboardConstants.Param_Label] || "";
    let labelParam = params[DashboardConstants.Param_Category] || "";
    let valueParam = params[DashboardConstants.Param_Value] || "";
    for (let i = 0; i < resultSetSize(values); i++) {
        if (categParam.contains(",") || labelParam.contains(",") || valueParam.contains(",")) {
            let rowCategories = geCSVColumns(i, categParam, values);
            let rowLabels = geCSVColumns(i, labelParam, values);
            let rowValues = geCSVColumns(i, valueParam, values);
            let maxSize = Math.max(rowCategories.size(), rowLabels.size(), rowValues.size());
            fillWithLastElement(rowCategories, maxSize);
            fillWithLastElement(rowLabels, maxSize);
            fillWithLastElement(rowValues, maxSize);
            for (let x = 0; x < maxSize; x++) {
                addDataLine(categs, labelWithValues, rowCategories.get(x), rowLabels.get(x), rowValues.get(x), params, values, i);
            }
        } else {
            addDataLine(categs, labelWithValues, getByColName(i, categParam, values), getByColName(i, labelParam, values), getByColName(i, valueParam, values), params, values, i);
        }
    }
    let dataSeries = [];
    for (let [label, values] of labelWithValues.entries()) {
        for (let val of values)
            dataSeries.push(val);
    }
    let widgetId = widget.attr('id');
    let chartData = {
        type: 'column',
    };
    chartData = prepareChartData(chartData, w, h);
    Highcharts.chart(widgetId, {
        chart: chartData,
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                point: {
                    events: {
                        click: handleChartClick
                    }
                }
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<br>{point.y:.1f}',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        xAxis: {
            categories: categs,
            labels: {
                rotation: -45
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: calcChartTitle(userDashboardChartLine)
            }
        },
        series: [{
            showInLegend: false,
            data: dataSeries,
        }]
    });
}